import { useState, useRef, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { subscribe } from 'actions';

import Icon from 'components/commons/Icon';
import Spinner from 'components/Spinner';
import Snackbar from 'components/Snackbar';

import {
  Wrapper,
  Header,
  Title,
  InputWrapper,
  Label,
  Input,
  SubscribeBtn,
  Content,
  Footer,
  Description,
  SpinnerWrapper,
  SuccessWrapper,
  SuccessTitle,
  SuccessDesc,
} from './styles';

const Subscribe = () => {
  const ref = useRef();
  const { formatMessage } = useIntl();
  const [isInputActive, setIsInputActive] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState({
    message: '',
    error: false,
    subscribe: false,
  });

  const wrongEmailText = useMemo(
    () =>
      formatMessage({
        id: 'wrongEmail',
      }),
    []
  );

  const notEnoughData = useMemo(
    () =>
      formatMessage({
        id: 'notEnoughData',
      }),
    []
  );

  const smthWrongMessage = useMemo(
    () =>
      formatMessage({
        id: 'smthWrongMessage',
      }),
    []
  );

  const handleSubmit = async e => {
    e.preventDefault();

    if (!inputValue) {
      setInfo({
        message: notEnoughData,
        error: true,
        subscribe: false,
      });

      return;
    }

    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.append('email', inputValue);
      formData.append('action', 'currency-subscribe-form');
      formData.append('r', 1);

      await subscribe(formData).then(res => {
        setInfo({
          message: res.data.code === 0 ? res.data.message : wrongEmailText,
          error: res.data.code === 500,
          subscribe: res.data.code === 0,
        });
      });
    } catch (err) {
      setInfo({
        message: smthWrongMessage,
        error: true,
        subscribe: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const closeError = () => {
    setInfo({
      message: '',
      error: false,
      subscribe: false,
    });
  };

  const descText = formatMessage({
    id: 'subscribe.desc',
  });

  return (
    <Wrapper>
      {info.subscribe && (
        <SuccessWrapper>
          <Icon name="okIcon" />

          <SuccessTitle>
            <FormattedMessage id="subcribe.success" />
          </SuccessTitle>

          <SuccessDesc>
            <FormattedMessage id="subscribe.success.desc" />
          </SuccessDesc>
        </SuccessWrapper>
      )}

      {!info.subscribe && (
        <>
          <Header>
            <Icon name="subscribe" />
            <Title>
              <FormattedMessage id="subscribe.title" />
            </Title>
          </Header>
          <Content>
            {info.subscribe && <div>testest</div>}

            {isLoading && (
              <SpinnerWrapper>
                <Spinner />
              </SpinnerWrapper>
            )}

            {!isLoading && (
              <form ref={ref} onSubmit={handleSubmit} noValidate>
                <InputWrapper>
                  <Label
                    isInputActive={isInputActive}
                    inputValue={inputValue}
                    onClick={() => setIsInputActive(true)}
                    htmlFor="email"
                  >
                    Email
                  </Label>
                  <Input
                    id="email"
                    type="email"
                    value={inputValue}
                    onChange={e => setInputValue(e.target.value)}
                    onFocus={() => setIsInputActive(true)}
                    onBlur={() => setIsInputActive(false)}
                  />
                </InputWrapper>
                <SubscribeBtn type="submit">
                  <FormattedMessage id="subscribe" />
                </SubscribeBtn>
              </form>
            )}
          </Content>
          <Footer>
            <Description>{descText}</Description>
          </Footer>
        </>
      )}
      <Snackbar isOpen={info.error} onRequestClose={closeError}>
        {info.message}
      </Snackbar>
    </Wrapper>
  );
};

export default Subscribe;
